import React, { useContext } from 'react';

import './About.css';
import { ThemeContext } from '../../contexts/ThemeContext';
import { aboutData } from '../../data/aboutData'



function About() {

    const { theme } = useContext(ThemeContext);
    return (
        <div className="about" id="about" style={{backgroundColor: theme.secondary}}>
            <div className="line-styling">
              <div className="style-circle" style={{backgroundColor: theme.primary}}></div>
              <div className="style-circle" style={{backgroundColor: theme.primary}}></div>
              <div className="style-line" style={{backgroundColor: theme.primary}}></div>
            </div>
            <div className="about-body">
                <div className="about-description">
                    <h2 style={{color:theme.tertiary80,fontFamily: "cursive"}}>{aboutData.title}</h2>
                    <p style={{color:theme.tertiary80,fontFamily: "cursive"}}>{aboutData.description1}<br/><br/>{aboutData.description2}</p><br></br>
                    <pre style={{color:theme.tertiary80,fontFamily: "cursive",fontSize: "1.0rem"}}>{aboutData.description3}</pre>
                </div>
                <div className="about-img">
                    <img 
                        src={aboutData.image === 2 ? theme.aboutimg1 : theme.aboutimg2}  
                        alt="" 
                    />
                </div>
            </div>
        </div>

    )
}

export default About
